import { render, staticRenderFns } from "./PhoneNumbersPropertyEditAction.vue?vue&type=template&id=2da332d9"
import script from "./PhoneNumbersPropertyEditAction.vue?vue&type=script&lang=js"
export * from "./PhoneNumbersPropertyEditAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports